import { portalText } from "../../i18n/portal.js";
/**
 * How many of a workspace's VoiceAgents answer, and how many failed (customer-portal review
 * 2026-09-25 #161: five failed agents counted in "7 agents" and in the header's "7", as if all
 * seven worked).
 */
import type { WorkspaceVoiceAgentView } from "../../api/gateway.js";

export interface VoiceAgentTally {
  readonly total: number;
  readonly answering: number;
  readonly failed: number;
  /** "7 agents · 2 live · 5 failed", "1 agent · 1 live", "No agents". */
  readonly text: string;
}

export function voiceAgentTally(voiceAgent: readonly WorkspaceVoiceAgentView[]): VoiceAgentTally {
  const total = voiceAgent.length;
  const answering = voiceAgent.filter((one) => one.state === "live").length;
  const failed = voiceAgent.filter((one) => one.state === "failed").length;
  if (total === 0) return { total, answering, failed, text: portalText("core", "workspaces.no_agents_56b58f") };
  const part = [portalText("core", "workspaces.agents_count", { count: total }), portalText("core", "workspaces._live_e4db76", { value0: String(answering) })];
  if (failed > 0) part.push(portalText("core", "workspaces._failed_1247d4", { value0: String(failed) }));
  return { total, answering, failed, text: part.join(" · ") };
}

/** The state as the table's tag says it: "Live", "Failed", "Draft"… */
export function voiceAgentStateLabel(state: string): string {
  return state.length === 0 ? state : state.charAt(0).toUpperCase() + state.slice(1);
}
